<template>
  <v-dialog :value="value" @input="showModal" max-width="500px">
    <v-card>
      <v-card-text>
        <p>Are you sure you want to delete {{ label }}?</p>
        <v-btn @click="showModal(false)">Cancel</v-btn>
        <v-btn @click="emitDelete" color="error">Delete</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ['value', 'label'],
    methods: {
      showModal(show) {
        this.$emit('input', show);
      },
      emitDelete() {
        this.showModal(false);
        this.$emit('delete');
      }
    }
  };
</script>

<style scoped>

</style>
